import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  List,
  ListItem,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { RiderContext } from "../../../../context";
import { useTestIds } from "../../../../hooks/useTestIds";
import DeviceDetails from "./DeviceDetails";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
    paddingBottom: theme.spacing(2),
  },
  dialogContent: {
    paddingLeft: theme.spacing(2),
  },
  dialogActions: {
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
    paddingTop: theme.spacing(2),
  },
  deviceDetails: {
    borderLeft: `1px solid ${theme.palette.background.selected}`,
    paddingLeft: theme.spacing(2),
  },
  selected: {
    paddingLeft: 0,
    color: theme.palette.primary.button,
  },
  unselected: {
    paddingLeft: 0,
  },
  closeButton: {
    backgroundColor: "#404858",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: "500",
    font: "Roboto",
    padding: "10px",
    width: "80px",
  },
}));

const ManageDevicesModal = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const history = useHistory();
  const location = useLocation();
  const testIds = useTestIds("rider-profile-manage-devices-modal");
  const { t } = useTranslation();
  const { riderId } = useParams();

  const [isOpen, setIsOpen] = useState(true);
  const [selectedDevice, setSelectedDevice] = useState(null);

  const { userDevices, fetchWalletTransactions, fetchWallet } = useContext(RiderContext);

  useEffect(() => {
    fetchWallet(riderId);
    fetchWalletTransactions(riderId);
  }, [location]);

  useEffect(() => {
    if (userDevices && !selectedDevice) setSelectedDevice(userDevices[0]);
  });

  const handleClose = (e = null) => {
    if (e) e.stopPropagation();
    setIsOpen(false);
    history.goBack();
  };

  return (
    <Dialog
      data-testid={testIds.wrapper}
      open={isOpen}
      onClose={handleClose}
      maxWidth="md"
      PaperProps={{ style: { padding: "0 48px", width: "800px", maxHeight: "568px" } }}
    >
      <DialogTitle data-testid={testIds.title} style={{ padding: "32px 0" }}>
        {t("Riders.Wallet.Devices.Title")}
      </DialogTitle>

      <DialogContent style={{ padding: 0 }} className={classes.dialogContent}>
        <Grid style={{ padding: 0 }} container grid-xs-12="true" justify="flex-start">
          <Grid item xs={3}>
            <List>
              {userDevices?.length
                ? userDevices.map((device, idx) => (
                    <ListItem
                      data-testid={`${testIds.deviceListItem}-${idx}`}
                      key={device.id}
                      button
                      onClick={() => setSelectedDevice(device)}
                      className={
                        device.id === selectedDevice?.id ? classes.selected : classes.unselected
                      }
                    >
                      {device.model}
                    </ListItem>
                  ))
                : t("Riders.Wallet.Devices.NoDevicesFound")}
            </List>
          </Grid>
          <Grid item xs={9} className={classes.deviceDetails}>
            {selectedDevice && <DeviceDetails device={selectedDevice} />}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: "32px 0" }}>
        <Button
          className={classes.closeButton}
          onClick={handleClose}
          data-testid={testIds.closeButton}
        >
          {t("Riders.Wallet.Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManageDevicesModal;
